export default "__VITE_ASSET__CubPR9PD__"